export interface TsAppVersion {
    version: string;
    name: string;
    description?: string;
    versionLong?: string;
    versionDate: string;
    gitCommitHash?: string;
    gitCommitDate?: string;
    gitTag?: string;
};

export const versions: TsAppVersion = {
    version: '2.6.0',
    name: 'fpar',
    versionDate: '2026-02-12T14:09:18.186Z',
};
export default versions;
